"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* AriaSDK.ts
* Author: Abhilash Panwar (abpanwar)
* Copyright: Microsoft 2016
*/
var Enums_1 = require("../common/Enums");
exports.AWTPiiKind = Enums_1.AWTPiiKind;
var AWT_1 = require("./AWT");
exports.AWT = AWT_1.default;
exports.AWT_COLLECTOR_URL_UNITED_STATES = 'https://us.pipe.aria.microsoft.com/Collector/3.0/';
exports.AWT_COLLECTOR_URL_GERMANY = 'https://de.pipe.aria.microsoft.com/Collector/3.0/';
exports.AWT_COLLECTOR_URL_JAPAN = 'https://jp.pipe.aria.microsoft.com/Collector/3.0/';
exports.AWT_COLLECTOR_URL_AUSTRALIA = 'https://au.pipe.aria.microsoft.com/Collector/3.0/';
exports.AWT_COLLECTOR_URL_EUROPE = 'https://eu.pipe.aria.microsoft.com/Collector/3.0/';
